import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Toast = () => {
  return (
    <ToastContainer
      position="top-right"
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      theme="light"
      limit={10}
    />
  );
};

export const showToast = (message, type, toastId, autoClose = 5000) => {
  toast(message, { type, toastId, autoClose });
};

export default Toast;
